import { createFileRoute } from "@tanstack/react-router"
import { Layout } from "@/layouts/Layout.tsx"

export const Route = createFileRoute("/_unauthorized")({
  ssr: false,
  component: Layout,
})
